export default function selected(target,url, selectedItems){
    let imageElements = document.querySelectorAll('.image-picker-item');
    for(let i=0;i<imageElements.length;i++){
        imageElements[i].classList.remove('image-picker-selected');
    }
    if(target.classList.contains('image-picker-selected')){
        target.classList.remove('image-picker-selected');
        if(selectedItems.includes(url)){
            const index = selectedItems.indexOf(url);
            if (index > -1) {
                selectedItems.splice(index, 1);
            }
        }
    }else{
        target.classList.add('image-picker-selected');
        if(!selectedItems.includes(url)){
            selectedItems[0] = url;
        }
    }  
    sessionStorage.setItem('selected_item', JSON.stringify(selectedItems));
}